import { combineReducers } from "redux";
import { bonusRules } from "./BonusRuleReducer";
import { bonusXpress } from "./BonusXpressReducer";
import { circles } from "./CircleReducer";
import { configGroups } from "./ConfigGroupReducer";
import { dashboard } from "./DashboardReducer";
import { menu } from "./MenuReducer";
import { operationalUnits } from "./OperationalUnitReducer";
import { cashback } from "./CashbackReducer";
import { preferences } from "./PreferencesReducer";
import { customerCare } from "./CustomerCareReducer";
import { notifications } from "./NotificationsReducer";
import { users } from "./UserReducer";
import { identifications } from "./IdentificationReducer";
import { flows } from "./FlowReducer";
import { registration } from "./RegistrationReducer";
import { coupons } from "./CouponReducer";
import { interactionSearch } from "./InteractionSearchReducer";
import { gdpr } from "./GdprReducer";
import { einGeneratorTemplates } from "./EinGeneratorTemplateReducer";
import { appLinks } from "./AppLinkReducer";
import { carousels } from "./CarouselReducer";
import segmentReducer from "./SegmentReducer";
import { campaignExperimental } from "./CampaignExperimentalReducer";

const reducer = combineReducers({
  carousels,
  appLinks,
  preferences,
  bonusRules,
  bonusXpress,
  cashback,
  customerCare,
  operationalUnits,
  notifications,
  users,
  circles,
  identifications,
  flows,
  registration,
  coupons,
  dashboard,
  interactionSearch,
  gdpr,
  configGroups,
  menu,
  einGeneratorTemplates,
  segments: segmentReducer,
  campaignExperimental,
});

export default reducer;
export type State = ReturnType<typeof reducer>;
